import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function BrickMosaicPage() {
  return <ProductPageContent data={PRODUCT_PAGES["brick-mosaic"]} />;
}

export default BrickMosaicPage;
